import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-matrix",
  "use": "icon-leo-matrix-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-matrix\">\r\n<g transform=\"translate(-133.120 -133.120) scale(1.120000)\">\r\n<path d=\"M192 192h192v192H192V192zm288 0h192v192H480V192zm288 0h192v192H768V192zM192 480h192v192H192V480zm288 0h192v192H480V480zm288 0h192v192H768V480zM192 768h192v192H192V768zm288 0h192v192H480V768z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-matrix.svg
// module id = Hfj8
// module chunks = 478